module.exports = __webpack_public_path__ + "b675e402f4bbe42692c3dedd08037fdc.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/common/bookCovers/book2.png
 ** module id = 834
 ** module chunks = 0
 **/